import React, { FC, PropsWithChildren } from 'react';
import { StackProps } from '@mui/material';
import { Stack } from '@monorepo/nova-ui';
import { DASHBOARD_BACKGROUND_SVG } from './config/dashboard-background.config';
import {
  BackgroundSvgWrapper,
  DashboardBackground,
} from './styled/dashboard-background.styled';

export const DashboardLayout: FC<PropsWithChildren<StackProps>> = ({
  children,
  ...props
}) => {
  return (
    <Stack sx={{ position: 'relative' }}>
      <DashboardBackground>
        <BackgroundSvgWrapper
          dangerouslySetInnerHTML={{ __html: DASHBOARD_BACKGROUND_SVG }}
        />
      </DashboardBackground>
      <Stack
        sx={(theme) => ({
          marginLeft: {
            xs: theme.spacing(4),
            sm: theme.spacing(20),
          },
          marginRight: {
            xs: theme.spacing(4),
            sm: theme.spacing(20),
          },
          overflow: 'visible',
          position: 'relative',
          zIndex: 1,
        })}
        {...props}
      >
        {children}
      </Stack>
    </Stack>
  );
};
